export default __webpack_public_path__ + "static/media/img-guide-05.d6634373.png";